import { combineReducers } from "redux";
import {
    CREATE_PAYMENT,
    UPDATE_PAYMENT,
    DELETE_PAYMENT
} from '../../constants'
import { LOGOUT_USER } from "../../auth/constants";
import { REFRESH_STORE } from "../../app/constants";

export const paymentById = (state = {}, action) => {
    switch (action.type) {
        case CREATE_PAYMENT:
            return { ...state, [action.payload.id]: { ...action.payload }}
        case UPDATE_PAYMENT:
            return { ...state, [action.payload.id]: { ...state[action.payload.id], ...action.payload }}
        case DELETE_PAYMENT:
            return { ...state, [action.payload.id]: undefined }
        case LOGOUT_USER:
            return {}
        case REFRESH_STORE:
            return {}
        default:
            return state
    }
}

export const paymentAllIds = (state = [], action) => {
    switch (action.type) {
        case CREATE_PAYMENT:
            return [ ...state, action.payload.id ]
        case DELETE_PAYMENT:
            return state.reduce((prevState, curId) => curId !== action.payload.id ? [ ...prevState, curId] : prevState, [])
        case LOGOUT_USER:
            return []
        case REFRESH_STORE:
            return []
        default:
            return state
    }
}


export default combineReducers({
    byId: paymentById,
    allIds: paymentAllIds
})